export const USER = "User";
export const ADMIN = "Admin";
export const CS = "Customer Service";
export const SUPER_ADMIN = "Super Admin";
